var _defs, _path, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenual = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "menual_svg__\\uAD6C\\uC131_\\uC694\\uC18C_119_2",
  width: 26.169,
  height: 30.746
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".menual_svg__cls-2{fill:#fff}.menual_svg__cls-3{fill:#1d8fd9}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "menual_svg__\\uD328\\uC2A4_373",
  fill: "#1291d9",
  d: "M461.849 261.967h20.113a2.7 2.7 0 0 0 2.648-2.734v-20.264a2.7 2.7 0 0 0-2.648-2.734h-20.7a2.7 2.7 0 0 0-2.649 2.734v24.668a3.3 3.3 0 0 0 3.24 3.344H483.8a.837.837 0 0 0 0-1.673h-21.951a1.671 1.671 0 0 1 0-3.341",
  transform: "translate(-458.609 -236.235)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "menual_svg__\\uADF8\\uB8F9_976",
  transform: "translate(8.611 6.655)"
}, /*#__PURE__*/React.createElement("path", {
  id: "menual_svg__\\uD328\\uC2A4_374",
  d: "M473.2 246.836a4.55 4.55 0 0 1 2.512-.658 5.4 5.4 0 0 1 3.252.936 3.2 3.2 0 0 1 1.294 2.772 3.13 3.13 0 0 1-.561 1.9 6.5 6.5 0 0 1-1.261 1.2l-.613.477a1.86 1.86 0 0 0-.665.909 3.8 3.8 0 0 0-.112 1.022h-2.347a6.8 6.8 0 0 1 .276-2.022 3.6 3.6 0 0 1 1.157-1.286l.63-.493a2.2 2.2 0 0 0 .5-.511 1.74 1.74 0 0 0 .345-1.048 2.02 2.02 0 0 0-.385-1.2 1.61 1.61 0 0 0-1.4-.541 1.55 1.55 0 0 0-1.422.667 2.57 2.57 0 0 0-.419 1.385h-2.5a4.04 4.04 0 0 1 1.719-3.509m1.438 9.735h2.59v2.5h-2.59z",
  className: "menual_svg__cls-2",
  transform: "translate(-471.473 -246.178)"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "menual_svg__\\uADF8\\uB8F9_977",
  transform: "translate(3.131 26.687)"
}, /*#__PURE__*/React.createElement("path", {
  id: "menual_svg__\\uC120_57",
  d: "M0 0h22.703",
  className: "menual_svg__cls-2",
  transform: "translate(.168 .168)"
}), /*#__PURE__*/React.createElement("path", {
  id: "menual_svg__\\uD328\\uC2A4_375",
  d: "M486.157 276.442h-22.7a.167.167 0 1 1 0-.335h22.7a.167.167 0 0 1 0 .335",
  className: "menual_svg__cls-3",
  transform: "translate(-463.287 -276.107)"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  id: "menual_svg__\\uADF8\\uB8F9_978",
  transform: "translate(3.131 27.782)"
}, /*#__PURE__*/React.createElement("path", {
  id: "menual_svg__\\uC120_58",
  d: "M0 0h22.703",
  className: "menual_svg__cls-2",
  transform: "translate(.168 .167)"
}), /*#__PURE__*/React.createElement("path", {
  id: "menual_svg__\\uD328\\uC2A4_376",
  d: "M486.157 278.077h-22.7a.167.167 0 1 1 0-.335h22.7a.167.167 0 1 1 0 .335",
  className: "menual_svg__cls-3",
  transform: "translate(-463.287 -277.742)"
}))));
export { SvgMenual as ReactComponent };
export default __webpack_public_path__ + "static/media/menual.3448da22.svg";